import { Icon, Typo } from "@pepperstone/pepper-ui-kit";

export type FieldErrorProps = {
  text: string;
  withIcon?: boolean;
  className?: string;
};

export const FieldError = ({
  text,
  withIcon = true,
  className,
}: FieldErrorProps) => (
  <div className={`flex items-start gap-2 ${className || "text-red-700"}`}>
    {withIcon && (
      <span className="mt-[3px] shrink-0">
        <Icon icon="alert-triangle" size={12} />
      </span>
    )}
    <Typo elem="p" size="sm" type="body" classes="pt-[3px]">
      {text}
    </Typo>
  </div>
);
